const state = {
  result: {},
  pagination: {
    currentPage: 1,
    perPage: 10,
  },
  advanceFilter: false,
  catalog: {
    academicYears: [],
    caats: [],
    centers: [],
    municipalities: [],
    referralTypes: [],
    schools: [],
    statuses: [],
  },
  filter: {
    academicYear: null,
    caat: null,
    center: null,
    municipality: null,
    referredType: null,
    school: null,
    sie: null,
    status: null,
    student: null,
  },
};

export default state;
